import React from 'react';

export interface LupaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const LupaIcon: React.FC<LupaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path fill="currentColor" d="m19.933 21-6.3-6.3q-.75.6-1.725.95-.974.35-2.075.35-2.725 0-4.612-1.887T3.333 9.5t1.888-4.612T9.833 3t4.613 1.888T16.333 9.5a6.1 6.1 0 0 1-1.3 3.8l6.3 6.3zm-10.1-7q1.875 0 3.188-1.312 1.312-1.313 1.312-3.188t-1.312-3.187T9.833 5 6.646 6.313 5.333 9.5t1.313 3.188T9.833 14"/>
    </svg>
  );
};

export default LupaIcon;
